import { Behavior } from './Behavior';
import { ContentType, LessonMode, QuestionFeedbackState } from '../../Constants';
import UtilsService from '../services/UtilsService';

export class LikertBehavior extends Behavior {
  checkForValidResponse = (responseAnswer) => {
    // Check that at least one prompt has at least one answer selected
    const valid = Object.keys(responseAnswer.answers).length === 0 && responseAnswer.answers.constructor === Object;
    return !valid;
  }

  setCorrectAnswer = (state, model) => {
    const temp = {
      answers: {} ,
      lessonElementId: model.lessonElementId
    };
    state.setCurrentResponse(UtilsService.safeMobxClone(temp));
  }

  resetStudentAnswer = (state, validation) => {
    state.setCurrentResponse(UtilsService.safeMobxClone(state.cachedResponseAnswer));
  }

  isAutoScored = (model) => {
    return false;
  }

  setResponseData = (data, responseAnswer, model) => {
    const { promptId, value, index } = data;
    responseAnswer.answers[promptId] = { index:index, value:parseInt(value)};
  }

  getInitializedResponse = (lessonElementId, model) => {
    const responseAnswer = {
      answers: {},
      lessonElementId
    };
    return responseAnswer;
  }

  getCorrectAnswersText = (model) => {
    // Answers shown in question body. Nothing needs to be done here.
  }

  getQuestionFeedbackText = (model, correctFeedback, incorrectFeedback, correctFeedbackBody, incorrectFeedbackBody, mode, questionIsCorrect, currentAttemptCount, { lessonElementState }) => {
    let textBody = '';
    if (mode === LessonMode.PREVIEW || mode === LessonMode.ITEM_PREVIEW || mode === LessonMode.STUDENT_PREVIEW || mode === LessonMode.PUBLISHER_PREVIEW) {
      textBody += UtilsService.previewWarning();
    } else {
      textBody += UtilsService.saveCommit();
    }

    let finalText = '<div class=\'question-feedback-header\'>';
    finalText += '';
    finalText += '</div>';
    finalText += '<div class=\'question-feedback-body\'>';
    finalText += textBody;
    finalText += '</div>';

    return finalText;
  }

  isQuestionCorrect = (lessonElementState, lessonElementId) => {
    return QuestionFeedbackState.CORRECT;
  }
}
export default new LikertBehavior();
